<template>
  <div class="admin-tools">
    <div class="header">
      <div class="title">Admin Tools</div>
      <div class="description">Designed for CHeKT service administrators</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          Thanks for being one of CHeKT service administrators.
        </div>
      </div>
    </div>
    <div class="apps">
      <!-- operation portal -->
      <div class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'operation'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Console Portal</div>
        <div class="description">Console Portal for CHeKT Admin to support CHeKT customers.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL($env.operationWebUrl)" ontouchstart=""
          class="action-btn">Open Console Portal</div>
        </div>
      </div>
      <!-- operation portal v2 -->
      <!-- <div class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'operation-v2'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">Operation Portal V2 (beta)</div>
        <div class="description">Operation Portal V2 for CHeKT Admin to support CHeKT customers.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL($env.operationV2WebUrl)" ontouchstart=""
          class="action-btn">{{$env.operationV2WebUrl}}</div>
        </div>
      </div> -->
      <!-- AWS console -->
      <div class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'aws-console'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">AWS Cloud Console</div>
        <div class="description">AWS Cloud Console for CHeKT Admin to maintain cloud servers.</div>
        <div class="action-btns">
          <div
          v-on:click="goToURL('https://chekt-service.signin.aws.amazon.com/console')" ontouchstart=""
          class="action-btn">Open AWS Console</div>
        </div>
      </div>
      <!-- status -->
      <div class="app card-container">
        <div class="icon-container">
          <comp-app-icon
          v-bind:icon="'status'"
          v-bind:width="appIconWidth"></comp-app-icon>
        </div>
        <div class="title">CHeKT Service Status</div>
        <div class="description">CHeKT Service Status to check service operation status in real time.</div>
        <div class="action-btns" style="display: flex; flex-direction: row;">
          <div
          v-on:click="goToURL('http://status.chekt.com')" ontouchstart=""
          class="action-btn">Opesn Status</div>
          <div class="action-btn" style="margin: 0 4px">/</div>
          <div
          v-on:click="goToURL('http://uptime.chekt.com')" ontouchstart=""
          class="action-btn">Open Uptime</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompAppIcon from '@/components/CompAppIcon'
export default {
  name: 'admin-tools',
  components: {
    CompAppIcon
  },
  data: function () {
    return {
      appIconWidth: 340
    }
  },
  methods: {
    goToURL: function (url) {
      this.$tool.openNewTab(url)
    }
  }
}
</script>

<style scoped>

.admin-tools {
  /* size */
  width: 100%;
  height: 100%;
}

.admin-tools .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* alignment */
  text-align: left;
}
.admin-tools .header .title {
  /* common */
  font-size: 3em;
  /* text */
  font-weight: bold;
}
.admin-tools .header .description {
  /* common */
  font-size: 1.5em;
}

.admin-tools .apps {
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.admin-tools .app {
  /* common */
  font-size: 16px;
  /* size */
  max-width: 300px;
  width: 100%;
  /* position */
  margin-right: 2em;
  margin-bottom: 1em;
  /* alignment */
  text-align: left;
}
.admin-tools .app .title {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 16px;
  /* text */
  font-weight: bold;
  line-height: 2rem;
  /* position */
  margin-top: 1.5rem;
  margin-bottom: 10px;
}
.admin-tools .app .description {
  /* common */
  overflow: hidden;
  border-radius: 4px;
  font-size: 14px;
  /* text */
  color: var(--gray-medium);
  /* position */
  margin-bottom: 10px;
}
.admin-tools .app .icon-container {
  /* common */
  overflow: hidden;
  border-radius: 4px;
}

.admin-tools .app .action-btns {
  /* common */
  font-size: 14px;
  /* size */
  padding-right: 0.5em;
  /* position */
  margin-bottom: 10px;
  /* alignment */
  display: flex;
  flex-direction: column;
}
.admin-tools .app .action-btns .action-btn {
  /* common */
  color: var(--gray-low);
  /* mouse */
  cursor: pointer;
}
.admin-tools .app .action-btns .action-btn:hover {
  /* common */
  color: var(--primary);
}



.admin-tools .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid #dedede;
  /* alignment */
  text-align: left;
}

.admin-tools .body .content {
  /* common */
  color: var(--gray-medium);
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: 100%;
  /* min-height: 4em; */
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}

.admin-tools .body .content .info-container:first-child {
  margin-top: 0;
}
.admin-tools .body .content .info-container {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  margin: 1em 0;
  /* alignment */
  display: table;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/AdminTools.vue